import { SearchIcon } from "@heroicons/react/solid";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { FullSpinner } from "../../../components/LoadingSpinner";
import SkillsList from "../../../components/skills-list/SkillsList";
import { useSkills } from "../../../hooks/useSkills";
import { indexStudentSkills } from "../../../api/endpoints/students/skills";

export default function StudentSkillsView() {
  const { t, i18n } = useTranslation("", {
    keyPrefix: "page.candidate.dashboard.recitationSkills",
  });

  const { data: finishedSkills } = useQuery(
    ["studentSkills"],
    indexStudentSkills,
    {
      select: (response) => {
        let skills: string[] | undefined = undefined;
        if (response.isSuccess) {
          skills = response.data?.skills;
        }
        return skills;
      },
    }
  );
  const { skills, onSkillClick, setSearch, setFinishedSkills } = useSkills([]);

  useEffect(() => {
    setFinishedSkills(finishedSkills || []);
  }, [finishedSkills, i18n.language]);

  if (!skills) return <FullSpinner size={40} />;
  return (
    <div className="w-full flex flex-col bg-gray-50">
      <div className="mx-4 md:mx-6 py-6 flex flex-col gap-5">
        <h2 className="text-2xl font-semibold text-gray-700 py-[3px]">
          {t("title")}
        </h2>
        <div className="relative rounded-md shadow-sm">
          <div className="absolute inset-y-0 start-0 ps-3  flex items-center pointer-events-none">
            <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
          <input
            type="text"
            name="search"
            id="search"
            className="block w-full ps-10 border border-gray-300 focus:ring-brandblue-500 focus:border-brandblue-500 text-sm rounded-md"
            placeholder={t("search")}
            onChange={(e) => {
              setSearch(e.target.value.trim());
            }}
          />
        </div>
      </div>
      <div className="w-full h-full flex flex-col bg-white">
        <div className="px-4 py-3 bg-gray-100 text-xs font-medium tracking-wider text-gray-500 border-y border-gray-200">
          {t("skills")}
        </div>
        <div className="skills-list">
          <SkillsList
            skills={skills}
            onSkillClick={onSkillClick}
            isEditable={false}
          />
        </div>
      </div>
    </div>
  );
}
